import React from 'react';
import { Droppable, Draggable, DroppableProvided } from 'react-beautiful-dnd';
import JobBox from './JobBox';

const JobListColumn = ({jobList, listId, listType, internalScroll, isCombineEnabled}) => {
    const renderBoard = (dropProvided) => {
        return (
            <div style={{display:'flex', flexDirection:'column', flexGrow:1, height:'100%'}} ref={dropProvided.innerRef}>
                {jobList.map((job,i)=>(
                    <Draggable key={job.id} draggableId={job.id} index={i}>
                        {(dragProvided)=>(
                            <div 
                                {...dragProvided.dragHandleProps}
                                {...dragProvided.draggableProps}
                                ref={dragProvided.innerRef}
                            >
                                <JobBox job={job} />
                            </div>
                        )}
                    </Draggable>
                ))}
            </div>
        )
    };


  return (
    <Droppable
        droppableId={listId}
        type={listType}
        direction='vertical'
        isCombineEnabled={isCombineEnabled}
        >
            {(dropProvided)=>(
                <div {...dropProvided.droppableProps} className="drag-column p-4 py-">
                    <div className='py-5'>
                        <h3 className='font-semibold text-center'>
                            {dropProvided.droppableProps['data-rbd-droppable-id'].toUpperCase()}
                        </h3>
                        <h4 className='text-center text-neutral-400'>
                            {jobList.length} Job{jobList.length===1?'':'s'}
                        </h4>
                    </div>
                    {internalScroll?(
                        <div style={{flexGrow:1, height:'100%'}}>
                            {renderBoard(dropProvided)}
                        </div>)
                        :
                        (<div>
                            {renderBoard(dropProvided)}
                        </div>
                    )}
                    {dropProvided.placeholder}
                </div>
            )}

    </Droppable>
  )
};
export default JobListColumn;